export var defaultInvalidDate = 'Invalid date';

export function invalidDate () {
    return this._invalidDate;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/locale/invalid.js
// module id = 401
// module chunks = 113